import {
  FILTER_KEY_AUTHORS,
  FILTER_KEY_EDITOR,
  FILTER_KEY_DELTA_RANK,
  FILTER_KEY_FORMAT,
  FILTER_KEY_SEGMENT1,
  FILTER_KEY_RANK,
  FILTER_KEY_SEGMENT2,
  FILTER_KEY_TITLE,
  FILTER_KEY_PUBLISHING_DATE,
} from './filters-items-dynamics.config'
import { TrendsItemFilterActionInterface } from '../../interface/dynamics/trends-item-filter-action.interface'
import { ReactComponent as RankIcon } from '../../../assets/icons/app/rank.icon.svg'
import { ReactComponent as ProgressIcon } from '../../../assets/icons/app/progress.icon.svg'
import { ReactComponent as FormatIcon } from '../../../assets/icons/app/format.icon.svg'
import { ReactComponent as TitleIcon } from '../../../assets/icons/app/title.icon.svg'
import { ReactComponent as EditorIcon } from '../../../assets/icons/app/editor.icon.svg'
import { ReactComponent as DateIcon } from '../../../assets/icons/app/release-year.icon.svg'
import { ReactComponent as SegmentIcon } from '../../../assets/icons/app/segment.icon.svg'
import { ReactComponent as AuthorIcon } from '../../../assets/icons/app/author.icon.svg'
import { ItemSortActionEnum } from '../../enums/item-filter-action.enum'

export const SortsItemsDynamicsConfig: TrendsItemFilterActionInterface[] = [
  {
    value: ItemSortActionEnum.Ranking,
    name: 'webApp.dynamics.results.filters.columns.rank',
    icon: <RankIcon className="w-4 h-4" />,
    active: false,
    key: FILTER_KEY_RANK,
  },
  {
    value: ItemSortActionEnum.Progress,
    name: 'webApp.dynamics.results.filters.columns.progress',
    icon: <ProgressIcon className="w-4 h-4" />,
    active: false,
    key: FILTER_KEY_DELTA_RANK,
  },
  {
    value: ItemSortActionEnum.Title,
    name: 'webApp.dynamics.results.filters.columns.title',
    icon: <TitleIcon className="w-4 h-4" />,
    active: false,
    key: FILTER_KEY_TITLE,
  },
  {
    value: ItemSortActionEnum.Author,
    name: 'webApp.dynamics.results.filters.columns.author',
    icon: <AuthorIcon className="w-4 h-4" />,
    active: false,
    key: FILTER_KEY_AUTHORS,
  },
  {
    value: ItemSortActionEnum.ReleaseYear,
    name: 'webApp.dynamics.results.filters.columns.publishingDate',
    icon: <DateIcon className="w-4 h-4" />,
    active: false,
    key: FILTER_KEY_PUBLISHING_DATE,
  },
  {
    value: ItemSortActionEnum.Editor,
    name: 'webApp.dynamics.results.filters.columns.editor',
    icon: <EditorIcon className="w-4 h-4" />,
    active: false,
    key: FILTER_KEY_EDITOR,
  },
  {
    value: ItemSortActionEnum.Segment1,
    name: 'webApp.dynamics.results.filters.columns.clil1',
    icon: <SegmentIcon className="w-4 h-4" />,
    active: false,
    key: FILTER_KEY_SEGMENT1,
  },
  {
    value: ItemSortActionEnum.Segment2,
    name: 'webApp.dynamics.results.filters.columns.clil2',
    icon: <SegmentIcon className="w-4 h-4" />,
    active: false,
    key: FILTER_KEY_SEGMENT2,
  },
  {
    value: ItemSortActionEnum.Format,
    name: 'webApp.dynamics.results.filters.columns.format',
    icon: <FormatIcon className="w-4 h-4" />,
    active: false,
    key: FILTER_KEY_FORMAT,
  },
]
